import { metaDataWithPackageLoader as objectMetadata } from '@atlaskit/icon-object/metadata';

import { getIconName } from './get-icon-name';

// we use this to cache the result
let objectIconsPromise: Promise<unknown> | null = null;

export const getObjectIcons: () => Promise<unknown> = (): Promise<unknown> => {
	if (!objectIconsPromise) {
		objectIconsPromise = Promise.all(
			Object.keys(objectMetadata).map(async (name: string) => {
				try {
					const icon = await objectMetadata[name].packageLoader();
					return { name, icon: icon.default };
				} catch {
					throw new Error("Can't find name" + name);
				}
			}),
		)
			.then((newData) =>
				newData
					.map((icon) => {
						const metadata = objectMetadata[icon.name];
						return {
							[icon.name]: {
								keywords: metadata.keywords,
								component: icon.icon,
								componentName: metadata.componentName,
								packageName: metadata.package,
								iconName: getIconName(icon.name),
							},
						};
					})
					.reduce((acc, b) => ({ ...acc, ...b })),
			)
			.catch((error) => {
				// eslint-disable-next-line no-console
				console.error(error);
			});
	}
	return objectIconsPromise;
};
